import {actions as A} from '../constants/actions';

const defaultState = {
  showErrorMessage: false,
  callback: null,
  message: '',
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SHOW_GLOBAL_ERROR_MESSAGE:
      const {message, callback} = payload;
      return {...state, showErrorMessage: true, message, callback};

    case A.HIDE_GLOBAL_ERROR_MESSAGE:
      return {...state, showErrorMessage: false, message: '', callback: null};

    default:
      return state;
  }
}
